const C_Path = "/calc";
import { RouteDefine } from '@/types/route';
import Layout from '~/layout/index.vue'

const FeeCalcRoutes: RouteDefine = {
    path: C_Path,
    component: Layout,
    children: [
        {
            path: "",
            name: 'calc',
            component: () => import("./index.vue"),
            meta: {
                title: '费用计算器',
                isBack: true,
                isHeaderShow: true,
                anonymous: true
            },
        }
    ]
}

export default FeeCalcRoutes